import { createSlice } from "@reduxjs/toolkit";

const cartSlice = createSlice({
    name: "cart",
    initialState: {
        resDetails: {
            resName: '',
            resArea: '',
            resImg: '',
            resSla: {}
        },
        cartItems: []
    },
    reducers: {
        addItems: (state, action) => {
            const existingItem = state.cartItems.find((item) => item.id === action.payload.id)
            if (existingItem) {
                existingItem.quantity += 1;
              } else {
                state.cartItems.push({...action.payload, quantity: 1 });
              }
        },
        removeItems: (state, action) => {
            const existingItem = state.cartItems.find((item) => item.id === action.payload.id)
            if (existingItem && existingItem.quantity > 1) {
                existingItem.quantity -= 1;
              } else {
                state.cartItems = state.cartItems.filter((item) => item.id !== existingItem.id);
              }
        },
        clearCart: (state, action) => {
            state.cartItems = [];
        }
    }
})

export const {addItems, removeItems, clearCart} = cartSlice.actions;
export default cartSlice.reducer;